/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { RoleControllerPermissionSummaryViewModel } from "../types/RoleControllerPermissionSummaryViewModel.ts";

export const roleControllerPermissionSummaryViewModelSchema = z.object({
  controllerId: z.optional(z.number().int().describe("ID do controller.")),
  controllerName: z.string().describe("Nome do controller.").nullish(),
  canRead: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o perfil possui permissão de leitura neste controller.",
      ),
  ),
  canCreate: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o perfil possui permissão de criação neste controller.",
      ),
  ),
  canUpdate: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o perfil possui permissão de edição neste controller.",
      ),
  ),
  canDelete: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o perfil possui permissão de exclusão neste controller.",
      ),
  ),
}) as unknown as ToZod<RoleControllerPermissionSummaryViewModel>;
